// 分页大小
export const PAGE_SIZE = {
    DEFAULT: 20,
};

// 超时时间
export const TIME_OUT = {
    DEFAULT: 6000,
};

/** 未指定后端泳道时的默认值（请求头 x-env） */
export const DEFAULT_BACKEND_SWIMLANE = 'offline';
